import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { DataSourceDetailsContext } from "./DataSourceDetailsContext";

export const DataSourceDetailsProvider = ({ children }) => {
  const [dataSourceDetails, setDataSourceDetails] = useState(null);
  const [emailMessages, setEmailMessages] = useState([]);

  const value = useMemo(
    () => ({
      dataSourceDetails,
      setDataSourceDetails,
      emailMessages,
      setEmailMessages,
    }),
    [dataSourceDetails, emailMessages]
  );

  return (
    <DataSourceDetailsContext.Provider value={value}>
      {children}
    </DataSourceDetailsContext.Provider>
  );
};

DataSourceDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
